import InfoIconOutlined from '@mui/icons-material/InfoOutlined';
import { Stack, Tooltip, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

const LabelWithTooltipIcon = ({
  labelKey,
  tooltipKey,
}: {
  labelKey: string;
  tooltipKey: string;
}) => {
  const { formatMessage } = useIntl();
  return (
    <Stack spacing={1} direction="row" alignItems="center">
      <Typography variant="body1" fontWeight="medium">
        <FormattedMessage id={labelKey} />
      </Typography>
      <Tooltip title={formatMessage({ id: tooltipKey })} arrow placement="left">
        <InfoIconOutlined color="action" />
      </Tooltip>
    </Stack>
  );
};

export default LabelWithTooltipIcon;
